/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "bjylempevckvbpzpiicx"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJqeWxlbXBldmNrdmJwenBpaWN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg5MDI1ODgsImV4cCI6MjA4NDQ3ODU4OH0.QNgiklDhLOSD_cCCKvKg8CLgatgldvoT4pn3oRYH0lc"